import { render, staticRenderFns } from "./LiffTest.vue?vue&type=template&id=e54e3258&"
import script from "./LiffTest.vue?vue&type=script&lang=js&"
export * from "./LiffTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports